export default __webpack_public_path__ + "img/2688548b231f1caa2f1063a9371352e5.png";